import React from 'react';
import { useTranslation } from 'react-i18next';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Merge ({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.DATA-TABLE.MERGE.';
    return (
        <div>
            <div className="form-element">
                {t(label + 'FIRST-TABLE')}
                <VariablePicker action={action} inputName="firstTable" variables={variables} setOpenVariable={setOpenVariable} filter="data table" isRequired/>
                <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
            </div>
            <div className="form-element">
                {t(label + 'SECOND-TABLE')}
                <VariablePicker action={action} inputName="secondTable" variables={variables} setOpenVariable={setOpenVariable} filter="data table" isRequired/>
                <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
            </div>
            <div className="form-element">
                {t(label + 'RESULT-TABLE')}
                <VariablePicker action={action} inputName="resultTable" variables={variables} setOpenVariable={setOpenVariable} filter="data table" isRequired/>
                <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
            </div>
        </div>
    );
}
export default Merge;